import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  AfterContentInit,
} from '@angular/core';
import { WebsiteService } from 'src/app/apps/website/website.service';
import { tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-content-builder',
  templateUrl: './content-builder.component.html',
  styleUrls: ['./content-builder.component.less'],
})
export class ContentBuilderComponent
  implements OnInit, OnDestroy, AfterContentInit
{
  @Output() Content = new EventEmitter();
  grapesjs = require('grapesjs');
  editor: any;
  subscriptions: Subscription[] = [];
  webpack = require('grapesjs-preset-webpage');
  slider = require('grapesjs-lory-slider');
  constructor(private websiteService: WebsiteService) {}

  ngOnInit() {
    this.editor = this.grapesjs.init({
      container: '#gjs',
      height: '100%',
      width: 'auto',
      plugins: ['gjs-preset-webpage', 'grapesjs-lory-slider'],
      panels: {},
      storageManager: false,
      fromElement: true,
    });
    this.getBlocks();
  }
  ngAfterContentInit(): void {
    this.runSubscribers();
  }
  onSaveContent() {
    const html = this.editor.getHtml();
    const css = this.editor.getCss();
    const content = {
      html,
      css,
    };
    this.Content.emit(content);
  }
  ClearContent() {
    this.editor.DomComponents.clear();
  }
  getBlocks() {
    this.websiteService
      .getBlocks()
      .pipe(
        tap((blocks) => {
          console.log(blocks);
          blocks.forEach((block) => {
            const content: { html: string; css: string } = JSON.parse(
              block.Content
            );
            this.editor.BlockManager.add(block.Code, {
              label: block.Title,
              content: content.html,
              category: 'Custom Blocks',
              media: '<i class="fas fa-th-large" style="font-size:35px"></i>',
            });
          });
        })
      )
      .subscribe();
  }

  initializeContent(content) {
    this.editor.setComponents(content.html);
    this.editor.setStyle(content.css);
  }

  runSubscribers() {
    const clearSub = this.websiteService.clearPanelEmitter.subscribe(() => {
      this.ClearContent();
    });
    this.subscriptions.push(clearSub);
    const initSub = this.websiteService.initContentEmitter.subscribe(
      (content) => {
        this.initializeContent(content);
      }
    );
    this.subscriptions.push(initSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => {
      sub.unsubscribe();
    });
  }
}
